import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, ListItemIcon, Stack } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import request, { gql } from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import {
  AllOpportunityTypeByMasterQuery,
  AllOpportunityTypeByUserQuery,
  AllOpportunityTypeQuery,
} from "../../lib/graphQL/graphQuery";
import PageLoading from "../../components/Loading/PageLoading";
import TableComponent from "../../components/GridTable/TableComponent";

export default function OpportunityTypeListTable() {
  const { currentUser } = useAuth();
  const isUser = currentUser?.role;
  const navigate = useNavigate();
  const [opportunityTypeData, setOpportunityTypeData] = useState([]);

  const [id, setId] = useState("");
  const [status, setStatus] = useState(false);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchOpportunityTypeData();
    setStatus(false);
  }, [id, status]);


  //Table Mapping Function
  const opportunityTypeListTable = {
    columns: [
      {
        accessorFn: (row, index) => index + 1,
        label: "S.No",
        field: "sno",
        width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "OpportunityType ID",
        field: "optid",
        name: "OpportunityType ID",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "OpportunityType Name",
        field: "typeName",
        name: "OpportunityType Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Created By",
        field: "createdBy",
        name: "Created By",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Created At",
        field: "createdAt",
        name: "Created At",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
    ],
    rows: opportunityTypeData.reverse().map(
      (item, index) => (
        {
          sno: index + 1,
          id: item.id,
          optid: item.optid,
          typeName: item.typeName,
          description: item.description,
          createdBy: item.user.username,
          createdAt: item.createdAt ? item.createdAt.slice(0, 10) : "N/A",
        
        }
      )
    ),
  };

  //Data Fetching API Function
  const fetchOpportunityTypeData = () => {
    setIsLoading(true);
    request(
      BASEURL,
      isUser.toLowerCase() == "manager"
        ? AllOpportunityTypeByMasterQuery
        : isUser.toLowerCase() == "employee"
        ? AllOpportunityTypeByUserQuery
        : isUser.toLowerCase() == "superuser"
        ? AllOpportunityTypeQuery
        : "Data Not Found",
      { id: currentUser?.id }
    )
      .then((res) => {
        setOpportunityTypeData(
          isUser.toLowerCase() == "manager"
            ? res.getOpportunitytypeByMaster
            : isUser.toLowerCase() == "employee"
            ? res.getOpportunitytypeByUser
            : isUser.toLowerCase() == "superuser"
            ? res.allOpportunitytype
            : []
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //Add Button Function
  const handleNewOpportunityType = () => {
    navigate("/opportunityType/add-opportunityType");
  };

  //Row Click Function
  const onOpportunityTypeListClick = (e) => {
    if (e?.id) {
      navigate(`/opportunityType/add-opportunityType?${e?.id}`);
    }
  };

  const onCheck=(list)=>
    {
      console.log("id-c",list)
    }

    const onDeleteALL=()=>
      {
        console.log("id-DELE")
      }

      const onDelete=(id)=>
        {
          console.log("id-d",id)
        }

  return (
    <DashboardLayout>
      <TableComponent
      tableLoading={isLoading ? true : false}
      columns={opportunityTypeListTable.columns}
      rowsData={opportunityTypeListTable.rows}
      styles={{ paper: { padding: '16px' } }}
      head="Opportunity Type List"
      actions={true}
      checked={false}
      view={true}
      showAdd = {true}
      onCheck={onCheck}
      onEdit={onOpportunityTypeListClick}
      onDelete={onDelete}
      onView={onOpportunityTypeListClick}
      onDeleteALL={onDeleteALL}
      addList={() => handleNewOpportunityType()}
      />
      {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Opportunity Type List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewOpportunityType()}
              >
               Add OpportunityType
              </MaterialButton>
            </Stack>
          }
        />
       {!isLoading && <MaterialDataGrid
          rows={opportunityTypeListTable.rows}
          columns={opportunityTypeListTable.columns}
          isSelectable={false}
          onRowClick={onOpportunityTypeListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Opportunity Type found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any Opportunity Type details. Click on
                  the "Add Opportunity Type" button to start adding Opportunity
                  Type details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />}
             {isLoading && <PageLoading />}
      </Card> */}
    </DashboardLayout>
  );
}
